/** @jsx jsx */

import { ReactNode } from 'react';
import { isEmpty } from 'lodash';

import { jsx } from '@emotion/core';
import { Badge, Grid, Margin, Text } from '@zapier/design-system';

import Accordion from 'app/common/components/Accordion';

import HelpBlock, { HelpBlockProps } from './HelpBlock';

export const getStepTitle = (title: string, label: string): ReactNode => (
  <Grid alignItems="center" columns="80px auto" gap={15}>
    <Badge>{label}</Badge>
    <Text type="Body4">{title}</Text>
  </Grid>
);

const defaultProps = {
  helpText: {},
  isOpen: false,
};

type Props = {
  children: ReactNode;
  helpText?: HelpBlockProps;
  isInitiallyOpen: boolean;
  onExpand?: () => void;
  stepLabel: string;
  title: string;
};

const SetupStep = ({
  children,
  helpText,
  isInitiallyOpen,
  onExpand,
  stepLabel,
  title,
}: Props) => (
  <Margin margin="20px 0px">
    <Accordion
      isInitiallyOpen={isInitiallyOpen}
      onToggle={onExpand}
      title={getStepTitle(title, stepLabel)}
    >
      {!isEmpty(helpText) && (
        <HelpBlock
          description={helpText.description}
          heading={helpText.heading}
        />
      )}
      {children}
    </Accordion>
  </Margin>
);

SetupStep.defaultProps = defaultProps;

export default SetupStep;
